import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

export default function MissionVision() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Our Vision",
      content: "A world where every child, regardless of ability, is embraced with love and given the tools to thrive.",
      color: "bg-gh-blue",
      accent: "text-gh-orange"
    },
    {
      title: "Our Mission",
      content: "To provide a loving home, basic needs, and specialized support to orphaned and abandoned children in Mityana, empowering them with hope and a dignified future.",
      color: "bg-gh-orange",
      accent: "text-gh-blue"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 relative">
        {/* Slide Card */}
        <div className={`transition-all duration-700 ease-in-out rounded-3xl p-10 md:p-16 text-white shadow-2xl relative ${slides[currentSlide].color}`}>
          
          <Quote className="absolute top-10 right-10 opacity-20" size={80} />

          <div className="relative z-10 text-center">
            <h2 className={`text-sm font-black uppercase tracking-[0.4em] mb-6 ${slides[currentSlide].accent}`}>
              {slides[currentSlide].title}
            </h2>
            <p className="text-2xl md:text-3xl font-serif italic leading-relaxed">
              "{slides[currentSlide].content}"
            </p>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-3 mt-10">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-2 transition-all duration-300 rounded-full ${
                  currentSlide === index ? "w-10 bg-white" : "w-2 bg-white/40"
                }`}
              />
            ))}
          </div>
        </div>
        
        {/* Navigation Arrows */}
        <button 
          onClick={() => setCurrentSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1)}
          className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-6 bg-white p-2 rounded-full shadow-lg text-gh-blue hover:text-gh-orange transition"
        >
          <ChevronLeft size={24} />
        </button>
        <button 
          onClick={() => setCurrentSlide(currentSlide === slides.length - 1 ? 0 : currentSlide + 1)}
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-6 bg-white p-2 rounded-full shadow-lg text-gh-blue hover:text-gh-orange transition"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </section>
  );
}